

<div [className]="'login_Login'">
  <form class="form-signin text-center change_force_p">
    <div>
      <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
    </div>
    <div #container></div>
    <span id="MainContent_diverror" class="error-message">{{this.authService.error | translate}}</span>

    <label for="inputEmail" class="sr-only">{{ 'Login.EmailaddressSr' | translate }}</label>
    <input type="text" id="inputEmail" class="form-control" readonly="readonly" placeholder="{{ 'Login.UserName' | translate }}" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>
    <label for="inputPassword" class="sr-only">{{ 'Login.PasswordSr' | translate }}</label>

    <input type="password" id="inputPassword" class="form-control" placeholder="{{ 'Login.OldPassword' | translate }}" #password="ngModel" name="password" asp-for="Password" [(ngModel)]="user.oldPassword" required>

    <input type="password" id="inputPassword" class="form-control" placeholder="New Password" maxlength="25" #newpassword="ngModel" name="password" asp-for="Password" [(ngModel)]="user.password" required (keyup)="checkIfMatchingPasswords($event)">

    <!--<label class="text-danger" *ngIf="isShow && notValidPattern && submittedApplicationForm ">{{common?.message}}</label>-->

    <input type="password" id="inputPassword" class="form-control" placeholder="Confirm New Password" #confirmpassword="ngModel" name="password" asp-for="Password" [(ngModel)]="user.confirmPassword" required (keyup)="checkIfMatchingPasswords($event)">
    <div style="text-align:left;margin-top: -20px;">
      <label *ngIf="submittedApplicationForm && notEquivalent " class="text-danger">{{ 'Common.Passworddoesnotmatch' | translate }}</label>
    </div>
    <div style="text-align:left;margin-left:-15px;padding-top:15px">
      <ng9-password-strength-bar *ngIf="user.password" [passwordToCheck]="user.password"
                                 (onStrengthChanged)="strengthChanged()">
      </ng9-password-strength-bar>
    </div>

    <label class="text-danger" style="text-align:left;" *ngIf="user.password">{{common.message}}</label>

    <button class="btn btn-lg btn-primary btn-block btn_login" (click)="Save()">{{ 'Common.ChangePassword' | translate }}</button>
    <br />
    <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
  </form>
</div>

